import { ThemeLoader } from '~/components';

export const LoadingPage = () => (
  <div className="page-loader-container container">
    <ThemeLoader modal />
  </div>
);
